export const FEES_59140 = [{ to: 1697896947, feeUsd: '264110' }]
